module.exports = "images/doc-day-add-drag-print.7a24ba8e130b9cf90e9b81f6492aed34.png";